import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import React from 'react'

import Routes from './routes'
import { colors } from './utils'

export default () => (
  <ThemeProvider theme={colors.theme}>
    <CssBaseline />
    <Routes />
  </ThemeProvider>
)
